import { useIntl } from 'react-intl';
import DppModal from './DppModal';
import ReturnNumberForm from '../forms/ReturnNumberForm';

const ReturnNumberModal = ({ show, onSave, onClose }) => {
  const intl = useIntl();
  const modalTitle = intl.formatMessage({ id: 'action_set_return_number' });

  const handleSave = (data) => {
    onSave?.(data);
    onClose();
  };

  const footerButtons = (
    <></>
  );

  return (
    <DppModal
      show={show}
      handleClose={onClose}
      title={modalTitle}
      footerButtons={footerButtons}
      size="lg"
      centered
    >
      <ReturnNumberForm
        onSave={handleSave}
        onCancel={onClose}
        isModal={true}
      />
    </DppModal>
  );
};

export default ReturnNumberModal;